var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 370,
    viewBox: "0 0 90 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307 325L325 307L258.5 240.5L195 192L264.5 232L351 268L361 244L274 208L197 187.5L276 198H370V172.5H276L192.5 183.5L274.5 162L360.5 126L351 102.5L264.5 138.5L193.5 179L258.5 129.5L325 63L306.5 45L240.5 111L191 175.5L232 105.5L267.5 19L244 9.49998L208 95.5L186.5 177.5L197.5 93.5V-1.43051e-05H172V93.5L182.5 174L161.5 95.5L126 9.49998L102.5 19L138 105.5L177 173.5L129.5 111.5L63 45L45 63.5L111 129.5L176 179L105.5 138.5L19 102.5L9.5 126L95.5 162L174 183L93.5 172.5H7.00355e-07V198H93.5L173 187.5L96 208L9 244L19 267.5L105.5 231.5L177.5 189.5L111.5 240.5L45 307L63 325L129.5 258.5L180.5 192.5L138.5 264.5L102.5 351L126 361L162 274L182.5 197L172 276V370H197.5V276L187 196.5L208 274L244 361L267.5 351L231.5 264.5L189.5 192.5L240.5 258.5L307 325Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/✺.c33d3b51dc3163e0eb05216e2497c4b7.svg";
export { ForwardRef as ReactComponent };